module.exports = __webpack_public_path__ + "new1.jpg?dd0921775edf12e13dba6c684ea54d30";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new1.jpg
// module id = 83
// module chunks = 0